import * as React from 'react';
import { Fragment, useState } from 'react';
import {
    Button,
    Confirm,
    useDeleteMany,
    useRefresh,
    useNotify,
    useUnselectAll,
} from 'react-admin';

const ConfirmBulkDelete = ({ selectedIds, resource, basePath }) => {
    const [open, setOpen] = useState(false);
    const refresh = useRefresh();
    const notify = useNotify();
    const unselectAll = useUnselectAll();
    const [deleteMany, { loading }] = useDeleteMany(
        resource,
        selectedIds,
        {
            onSuccess: () => {
                refresh();
                unselectAll(resource);
            },
            onFailure: error => notify(`Error: ${resource} not updated`, 'warning'),
        }
    );
    const handleClick = () => setOpen(true);
    const handleDialogClose = () => setOpen(false);

    const handleConfirm = () => {
        if (resource === 'organizations' || resource === 'dispatch-tablets') {
            if (window.confirm(`Warning, this cannot be undone.`)) {
                deleteMany();
                setOpen(false);
            } else {
                handleDialogClose()
            }
        } else {
            deleteMany();
            setOpen(false);
        }
    };

    return (
        <Fragment>
            <Button style={{ color: 'red' }} label="Delete" onClick={handleClick} />
            <Confirm
                isOpen={open}
                loading={loading}
                title="Bulk Delete"
                content="Are you sure you want to delete these items?"
                onConfirm={handleConfirm}
                onClose={handleDialogClose}
            />
        </Fragment>
    );
}

export default ConfirmBulkDelete;